<div class="row">
	<p class="col-sm-3 col-xs-6">
		<button type="button" class="btn btn-primary btn-block white"
			(click)="exitCallback()">Esci</button>
	</p>
	<div class="col-sm-3 col-xs-6">
	<ng-template [ngIf]="(mnc === 0) && isToComplete(fascicolo) && urlConcludiInserimento && !isDatiGenerali">
		<p submitButton [labelButton]="'Completa'" (click)="completaInserimentoFascicolo()"></p>
	</ng-template>
	</div>
	<ng-template [ngIf]=" mnc >= 0 && !isDatiEconomici && (nextStep !== '')">
	<p *ngIf="!isLastStepWizard()"
		[ngClass]=" (mnc > 0) ? 'col-sm-3 col-xs-6 col-sm-offset-6' : 'col-sm-3 col-xs-6 col-sm-offset-3' ">
		<button type="button" class="btn btn-primary btn-block"
			[routerLink]="[ '/'+nextStep ]">Prosegui</button>
	</p>
	</ng-template>
	<ng-template [ngIf]=" mnc >= 0 && isDatiEconomici">
	<p submitButton [ngClass]=" (mnc > 0) ? 'col-sm-3 col-xs-6 col-sm-offset-6' : 'col-sm-3 col-xs-6 col-sm-offset-3' "
		[labelButton]=" (!isLastStepWizard()) ? 'Salva e Prosegui' : 'Salva'" [disabled]="disabled"
		(click)="onSubmitDatiEconomiciForm.emit($event)"></p>
	</ng-template>
	<p *ngIf="isLastStepWizard()" submitButton
		class="col-sm-3 col-xs-6 col-sm-offset-3"
		[labelButton]="'Fine'" (click)="concludiAssegnazioneLegale()"></p>
</div>
